import React from "react";
import { Header3 } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import TemplateTaskDependenciesItem from "./TemplateTaskDependenciesItem";

export const TemplateTaskDependenciesList = ({ tasks, parentId, isParent, title, className }) => {
  return (
    <>
      <Header3
        className="tw-mb-2"
        weight="bold"
      >
        {title}
      </Header3>
      <div className={classNames(className)}>
        {tasks.map((taskId, index) => {
          return (
            <TemplateTaskDependenciesItem
              key={index}
              id={taskId}
              parentId={parentId}
              isParent={isParent}
            />
          );
        })}
      </div>
    </>
  );
};

TemplateTaskDependenciesList.propTypes = {
  tasks: PropTypes.array.isRequired,
  parentId: PropTypes.number.isRequired,
  isParent: PropTypes.bool,
  title: PropTypes.string,
  className: PropTypes.string,
};

TemplateTaskDependenciesList.defaultProps = {
  isParent: false,
};
